import Dash from './Dash';

export default Dash;
export { Dash };
export type { DashProps } from './interface';
